/** Central flags while GraphQL models are removed for CloudFormation headroom. */
export const featureAvailability = {
  therapistBlog: {
    available: false,
    title: 'Therapist blog temporarily unavailable',
    description:
      'Creating and managing therapist blog posts is paused during infrastructure updates. Parent articles at /parents/blog are unaffected.',
  },
  teamManagement: {
    available: false,
    title: 'Team management temporarily unavailable',
    description:
      'Adding caregivers and clinicians to a care team is paused during infrastructure updates. Primary therapist and caregiver assignments on the child profile still work.',
  },
  diaryEntries: {
    available: false,
    title: 'Diary entries temporarily unavailable',
    description:
      'Timestamped diary entries are paused during infrastructure updates. General notes on profiles and milestone tasks still work.',
  },
  scratchpad: {
    available: false,
    title: 'Scratchpad temporarily unavailable',
    description:
      'Therapist scratchpad notes are paused during infrastructure updates. Session notes on milestones still work.',
  },
} as const;

export type FeatureKey = keyof typeof featureAvailability;

export function getFeatureMessage(key: FeatureKey) {
  return featureAvailability[key];
}
